import React from 'react';
import { ChevronRight, Filter, X } from 'lucide-react';
import { INSIGHT_TONE_STYLE } from '../utils/crmDashboardHelpers';

export default function CrmInsightsBar({
  topInsights,
  insightFilter,
  setInsightFilter,
  onOpenCliente,
}) {
  if (!Array.isArray(topInsights) || topInsights.length === 0) return null;

  return (
    <div className="crm-insights-bar">
      {topInsights.map((ins) => {
        const tone = INSIGHT_TONE_STYLE[ins.tone] || INSIGHT_TONE_STYLE.primary;
        const Icon = ins.icon;
        const isClickable = Boolean(ins.action);
        const isActive = ins.action === 'filter' && insightFilter === ins.key;
        const Component = isClickable ? 'button' : 'div';

        const handleClick = () => {
          if (!isClickable) return;
          if (ins.action === 'open' && ins.cliente) {
            onOpenCliente(ins.cliente);
            return;
          }
          if (ins.action === 'filter') {
            setInsightFilter((prev) => (prev === ins.key ? null : ins.key));
            setTimeout(() => {
              document
                .getElementById('crm-clients-section')
                ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 120);
          }
        };

        return (
          <Component
            key={ins.key}
            type={isClickable ? 'button' : undefined}
            onClick={isClickable ? handleClick : undefined}
            aria-pressed={ins.action === 'filter' ? isActive : undefined}
            className={`crm-insight-card${isClickable ? ' clickable' : ''}${isActive ? ' active' : ''}`}
            style={{
              '--insight-color': tone.color,
              '--insight-bg': tone.bg,
            }}
          >
            <div className="crm-insight-icon">
              <Icon size={18} />
            </div>
            <div className="crm-insight-body">
              <span className="crm-insight-title">
                {ins.label}
                {isActive && (
                  <span className="crm-insight-active-dot" aria-hidden="true">
                    <Filter size={9} /> filtrando
                  </span>
                )}
              </span>
              <span className="crm-insight-value">{ins.value}</span>
              <span className="crm-insight-sub">{ins.sub}</span>
            </div>
            {isClickable && (
              <div className="crm-insight-arrow" aria-hidden="true">
                {ins.action === 'filter' && isActive ? (
                  <X size={14} />
                ) : (
                  <ChevronRight size={14} />
                )}
              </div>
            )}
          </Component>
        );
      })}
    </div>
  );
}
